export default __webpack_public_path__ + "static/media/ArrowRight.ed22e7fa.svg";